export const enum UserType {
    commercial = "COMERCIAL",
    nonCommercial = "NO COMERCIAL",
}
